import React, {Suspense} from 'react';

const SaleComponent = React.lazy(() => import('../Component/SaleComponent/SaleComponent'));

function CustomerSalePage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <SaleComponent/>
            </Suspense>
        </>
    );
}

export default CustomerSalePage;